import { createFileRoute } from '@tanstack/react-router'

import { AppLayout } from '@/components/layout/app-layout'
import { requireAuth } from '@/lib/auth/guards'

export const Route = createFileRoute('/_app')({
  beforeLoad: requireAuth,
  component: AppLayout,
})
